/**
 * Helper de feedback visual para links de carrinho.
 *
 * Comportamento: ao clicar num link/botão de carrinho enquanto o usuário
 * já está na página /cart, dispara uma animação de "pulse" no próprio
 * elemento. Sem isso, o clique parece "não fazer nada" (Mithril detecta
 * mesma rota e não re-renderiza), o que é confuso.
 *
 * Uso: spread {...cartPulse()} num <a>/<button>.
 */
export function cartPulse() {
  return {
    onclick: e => {
      // Só dispara se já estamos no /cart.
      const path = m.route.get?.() || window.location.pathname;
      if (!path || !path.includes('/cart')) return;
      const el = e.currentTarget;
      if (!el) return;
      el.classList.remove('MpCartPulse');
      // Reflow para reiniciar a animação.
      void el.offsetWidth;
      el.classList.add('MpCartPulse');
      setTimeout(() => el.classList.remove('MpCartPulse'), 700);
    }
  };
}
flarum.reg.add('ramon-marketplace', 'common/utils/cartPulse', { cartPulse: cartPulse, });